import { FC } from "react";
import clsx from "classnames";
import { useStyles } from "./RotateScreen.style";
import Rotate from "./assets/rotate-img_1x.webp";
import Rotate2x from "./assets/rotate-img_2x.webp";
import Rotate3x from "./assets/rotate-img_3x.webp";

import {
  Image,
  Typography,
  TypographyColor,
  TypographyVariant,
} from "@onmo/ui";

export const RotateScreen: FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.rotateWarning}>
      <div className={classes.contentIcon}>
        <Image
          src={Rotate}
          src2x={Rotate2x}
          src3x={Rotate3x}
          className={clsx(classes.arrowRightToLeft, "runRightToLeft")}
        />
      </div>
      <Typography
        variant={TypographyVariant.BodyB3Bold}
        color={TypographyColor.Text1}
        className={classes.rotate}
      >
        {"Please rotate your device!"}
      </Typography>
    </div>
  );
};
